<template>
    <div>
    <div class="modal fade modern-modal" tabindex="-1" id="ModalEscolhaEnvolvidos" aria-hidden="true" data-bs-focus="false">
        <div class="modal-dialog modal-dialog-centered modal-xl modal-modern">
            <div class="modal-content modal-modern-content border-0">
                <button class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3"
                        :disabled="carregando"
                        data-bs-dismiss="modal">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                    </svg>
                </button>

                <div class="modal-modern-header">
                    <div class="header-icon" :class="modo === 'aprovacao' ? 'header-icon--aprovacao' : 'header-icon--revisao'">
                        <svg v-if="modo === 'aprovacao'" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M23.5 17L18.5 22L15 18.5L16.5 17L18.5 19L22 15.5L23.5 17M6 2C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H13.81C13.45 21.38 13.2 20.7 13.08 20H6V4H13V9H18V13.08C18.33 13.03 18.67 13 19 13C19.34 13 19.67 13.03 20 13.08V8L14 2M8 12V14H16V12M8 16V18H13V16Z" />
                        </svg>
                        <svg v-else xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M20 17H22V15H20V17M20 7V13H22V7M6 16H11V18H6M6 12H14V14H6M4 2C2.89 2 2 2.89 2 4V20C2 21.11 2.89 22 4 22H16C17.11 22 18 21.11 18 20V8L12 2M4 4H11V9H16V20H4Z" />
                        </svg>
                    </div>
                    <div class="header-text">
                        <h2>{{ tituloModal }}</h2>
                        <p>
                            Escolha <strong>usuários</strong> e/ou <strong>setores</strong> que poderão concluir esta etapa.
                            Basta que <strong>um</strong> deles finalize — os demais saem da fila automaticamente.
                        </p>
                    </div>
                    <div class="header-status">
                        <span v-if="loadingListas" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        <span v-if="totalSelecionados > 0" class="badge badge-counter">
                            {{ totalSelecionados }} selecionado(s)
                        </span>
                    </div>
                </div>

                <div class="modal-modern-body">
                    <div class="section-stack">
                    <!-- Resumo da seleção -->
                    <div v-if="totalSelecionados > 0" class="selection-summary">
                        <div class="selection-summary__header">
                            <span class="selection-summary__title">Destinatários selecionados</span>
                            <button type="button" class="btn btn-link btn-sm p-0 link-limpar" @click="limparSelecao">
                                Limpar tudo
                            </button>
                        </div>
                        <div class="selection-chips">
                            <span v-for="u in usuariosSelecionadosResumo" :key="'u-' + u.dsLogin" class="selection-chip selection-chip--user">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z" /></svg>
                                {{ u.nmUsuario || u.dsLogin }}
                                <button type="button" class="chip-remove" @click="toggleLogin(u.dsLogin, false)" aria-label="Remover">×</button>
                            </span>
                            <span v-for="s in setoresSelecionadosResumo" :key="'s-' + s.idSetor" class="selection-chip selection-chip--setor">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M18,15H16V17H18M18,11H16V13H18M20,19H12L8,23H4A2,2 0 0,1 2,21V3A2,2 0 0,1 4,1H20A2,2 0 0,1 22,3V17A2,2 0 0,1 20,19M4,3V21H7.17L11.17,17H20V3H4Z" /></svg>
                                {{ s.nmSetor }}
                                <button type="button" class="chip-remove" @click="toggleSetor(s.idSetor, false)" aria-label="Remover">×</button>
                            </span>
                        </div>
                    </div>

                    <!-- Busca global -->
                    <div class="global-search-bar">
                        <div class="input-group modern-input flex-grow-1">
                            <span class="input-group-text">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
                                    <path d="M21 21L16.65 16.65M18 10.5C18 14.6421 14.6421 18 10.5 18C6.35786 18 3 14.6421 3 10.5C3 6.35786 6.35786 3 10.5 3C14.6421 3 18 6.35786 18 10.5Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </span>
                            <input type="text"
                                   class="form-control"
                                   v-model="filtroGlobal"
                                   placeholder="Buscar usuário ou setor por nome, login ou código..." />
                        </div>
                        <button v-if="loginAtual && !loginAtualSelecionado"
                                type="button"
                                class="btn btn-outline-primary btn-sm btn-incluir-me"
                                @click="incluirMe">
                            Incluir-me
                        </button>
                    </div>

                    <div v-if="loadingListas" class="state-message state-message--loading">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Carregando usuários e setores...
                    </div>

                    <div v-else class="lists-grid">
                        <!-- Usuários -->
                        <div class="section-card section-card--compact">
                            <div class="section-header">
                                <div class="section-header__info">
                                    <div class="section-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M16,13C15.71,13 15.38,13 15.03,13.05C16.19,13.89 17,15.02 17,16.5V19H23V16.5C23,14.17 18.33,13 16,13M8,13C5.67,13 1,14.17 1,16.5V19H15V16.5C15,14.17 10.33,13 8,13M8,11A3,3 0 0,0 11,8A3,3 0 0,0 8,5A3,3 0 0,0 5,8A3,3 0 0,0 8,11M16,11A3,3 0 0,0 19,8A3,3 0 0,0 16,5A3,3 0 0,0 13,8A3,3 0 0,0 16,11Z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <h3>Usuários</h3>
                                        <p>{{ usuarios.length }} disponíveis no contrato</p>
                                    </div>
                                </div>
                                <div class="section-header__actions">
                                    <span v-if="loginsSelecionados.length" class="badge badge-counter">
                                        {{ loginsSelecionados.length }}
                                    </span>
                                </div>
                            </div>

                            <div class="section-content">
                                <div class="dependency-toolbar">
                                    <div class="toolbar-text">
                                        Selecione <strong>um ou mais usuários</strong> individualmente.
                                    </div>
                                    <div class="toolbar-actions">
                                        <div class="form-check form-switch modern-switch">
                                            <input class="form-check-input"
                                                   type="checkbox"
                                                   id="swSelectAllUsuarios"
                                                   :checked="todosUsuariosFiltradosSelecionados"
                                                   :disabled="filteredUsuarios.length === 0"
                                                   @change="toggleSelectAllUsuarios($event.target.checked)">
                                            <label class="form-check-label" for="swSelectAllUsuarios">Todos visíveis</label>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="filteredUsuarios.length === 0" class="state-message state-message--empty">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 16 16" fill="currentColor">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533z" />
                                        <circle cx="8" cy="4.5" r="1" />
                                    </svg>
                                    Nenhum usuário encontrado para o filtro informado.
                                </div>

                                <div v-else class="user-list-scroll">
                                    <label v-for="u in filteredUsuarios"
                                           :key="u.dsLogin"
                                           class="dependency-item"
                                           :class="{ 'dependency-item--selected': isLoginSelecionado(u.dsLogin) }">
                                        <div class="dependency-item__info">
                                            <input class="form-check-input dep-check"
                                                   type="checkbox"
                                                   :checked="isLoginSelecionado(u.dsLogin)"
                                                   @change="toggleLogin(u.dsLogin, $event.target.checked)" />
                                            <div class="item-text">
                                                <span class="dependency-title">
                                                    {{ u.nmUsuario || u.dsLogin }}
                                                    <span v-if="u.dsLogin === loginAtual" class="badge badge-me">Você</span>
                                                </span>
                                                <small class="dependency-description">{{ u.dsLogin }}</small>
                                            </div>
                                        </div>
                                        <span v-if="isLoginSelecionado(u.dsLogin)" class="badge badge-selected">Selecionado</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <!-- Setores -->
                        <div class="section-card section-card--compact">
                            <div class="section-header">
                                <div class="section-header__info">
                                    <div class="section-icon section-icon--setor">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M18,15H16V17H18M18,11H16V13H18M20,19H12L8,23H4A2,2 0 0,1 2,21V3A2,2 0 0,1 4,1H20A2,2 0 0,1 22,3V17A2,2 0 0,1 20,19M4,3V21H7.17L11.17,17H20V3H4Z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <h3>Setores</h3>
                                        <p>{{ setores.length }} setores cadastrados</p>
                                    </div>
                                </div>
                                <div class="section-header__actions">
                                    <span v-if="setoresSelecionados.length" class="badge badge-counter badge-counter--setor">
                                        {{ setoresSelecionados.length }}
                                    </span>
                                </div>
                            </div>

                            <div class="section-content">
                                <div class="dependency-toolbar">
                                    <div class="toolbar-text">
                                        Selecione <strong>um ou mais setores</strong> — qualquer membro ativo poderá atuar.
                                    </div>
                                    <div class="toolbar-actions">
                                        <div class="form-check form-switch modern-switch">
                                            <input class="form-check-input"
                                                   type="checkbox"
                                                   id="swSelectAllSetores"
                                                   :checked="todosSetoresFiltradosSelecionados"
                                                   :disabled="filteredSetores.length === 0"
                                                   @change="toggleSelectAllSetores($event.target.checked)">
                                            <label class="form-check-label" for="swSelectAllSetores">Todos visíveis</label>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="filteredSetores.length === 0" class="state-message state-message--empty">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 16 16" fill="currentColor">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533z" />
                                        <circle cx="8" cy="4.5" r="1" />
                                    </svg>
                                    Nenhum setor encontrado para o filtro informado.
                                </div>

                                <div v-else class="user-list-scroll">
                                    <label v-for="s in filteredSetores"
                                           :key="s.idSetor"
                                           class="dependency-item"
                                           :class="{ 'dependency-item--selected': isSetorSelecionado(s.idSetor) }">
                                        <div class="dependency-item__info">
                                            <input class="form-check-input dep-check"
                                                   type="checkbox"
                                                   :checked="isSetorSelecionado(s.idSetor)"
                                                   @change="toggleSetor(s.idSetor, $event.target.checked)" />
                                            <div class="item-text">
                                                <span class="dependency-title">{{ s.nmSetor }}</span>
                                                <small v-if="s.cdSetor" class="dependency-description">Código: {{ s.cdSetor }}</small>
                                            </div>
                                        </div>
                                        <span v-if="isSetorSelecionado(s.idSetor)" class="badge badge-selected">Selecionado</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="!podeConfirmar && !loadingListas" class="state-message state-message--warning">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 16 16" fill="currentColor">
                            <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2" />
                        </svg>
                        Selecione ao menos um usuário ou setor para continuar.
                    </div>
                    </div>
                </div>

                <div class="modal-modern-footer">
                    <div class="footer-actions">
                        <button type="button"
                                class="btn btn-modern-secondary"
                                data-bs-dismiss="modal"
                                :disabled="carregando">
                            Cancelar
                        </button>
                        <button type="button"
                                class="btn btn-modern-primary"
                                :disabled="!podeConfirmar || carregando || loadingListas"
                                @click="confirmar">
                            <span v-if="carregando" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            <span v-if="!carregando">{{ textoConfirmar }}</span>
                            <span v-else>Enviando...</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import { urlApi, avisoErro } from '@/config/global'

export default {
    name: 'ModalEscolhaEnvolvidos',
    props: {
        idProcessoArtefato: { type: Number, required: true },
        idProcesso: { type: Number, default: null },
        idProcessoModeloArtefato: { type: Number, default: null },
        modo: { type: String, default: 'revisao' },
    },
    data() {
        return {
            usuarios: [],
            setores: [],
            loginsSelecionados: [],
            setoresSelecionados: [],
            filtroGlobal: '',
            loadingListas: false,
            carregando: false,
        }
    },
    computed: {
        ...mapGetters(['getUser']),

        loginAtual() {
            return (this.getUser?.usuario?.dsLogin || '').trim() || null
        },

        tituloModal() {
            return this.modo === 'aprovacao' ? 'Enviar para Aprovação' : 'Enviar para Revisão'
        },
        textoConfirmar() {
            return this.modo === 'aprovacao' ? 'Enviar para Aprovação' : 'Enviar para Revisão'
        },
        cdTipoEnvolvido() {
            return this.modo === 'aprovacao' ? 2 : 1
        },
        filtroNormalizado() {
            return (this.filtroGlobal || '').trim().toLowerCase()
        },
        filteredUsuarios() {
            const q = this.filtroNormalizado
            const lista = [...this.usuarios].sort((a, b) =>
                (a.nmUsuario || a.dsLogin || '').localeCompare(b.nmUsuario || b.dsLogin || '', 'pt-BR', { sensitivity: 'base' })
            )
            if (!q) return lista
            return lista.filter(u => {
                const nome = String(u.nmUsuario || '').toLowerCase()
                const login = String(u.dsLogin || '').toLowerCase()
                return nome.includes(q) || login.includes(q)
            })
        },
        filteredSetores() {
            const q = this.filtroNormalizado
            const lista = [...this.setores].sort((a, b) =>
                (a.nmSetor || '').localeCompare(b.nmSetor || '', 'pt-BR', { sensitivity: 'base' })
            )
            if (!q) return lista
            return lista.filter(s => {
                const nome = String(s.nmSetor || '').toLowerCase()
                const cod = String(s.cdSetor || '').toLowerCase()
                return nome.includes(q) || cod.includes(q)
            })
        },
        totalSelecionados() {
            return this.loginsSelecionados.length + this.setoresSelecionados.length
        },
        usuariosSelecionadosResumo() {
            return this.loginsSelecionados
                .map(login => this.usuarios.find(u => u.dsLogin === login) || { dsLogin: login, nmUsuario: login })
        },
        setoresSelecionadosResumo() {
            return this.setoresSelecionados
                .map(id => this.setores.find(s => s.idSetor === id))
                .filter(Boolean)
        },
        todosUsuariosFiltradosSelecionados() {
            return this.filteredUsuarios.length > 0
                && this.filteredUsuarios.every(u => this.isLoginSelecionado(u.dsLogin))
        },
        todosSetoresFiltradosSelecionados() {
            return this.filteredSetores.length > 0
                && this.filteredSetores.every(s => this.isSetorSelecionado(s.idSetor))
        },
        loginAtualSelecionado() {
            return this.loginAtual && this.isLoginSelecionado(this.loginAtual)
        },
        podeConfirmar() {
            return this.loginsSelecionados.length > 0 || this.setoresSelecionados.length > 0
        },
    },
    methods: {
        isLoginSelecionado(login) {
            return this.loginsSelecionados.includes(login)
        },
        isSetorSelecionado(idSetor) {
            return this.setoresSelecionados.includes(idSetor)
        },
        toggleLogin(login, checked) {
            if (checked) {
                if (!this.loginsSelecionados.includes(login)) {
                    this.loginsSelecionados.push(login)
                }
            } else {
                this.loginsSelecionados = this.loginsSelecionados.filter(x => x !== login)
            }
        },
        toggleSetor(idSetor, checked) {
            if (checked) {
                if (!this.setoresSelecionados.includes(idSetor)) {
                    this.setoresSelecionados.push(idSetor)
                }
            } else {
                this.setoresSelecionados = this.setoresSelecionados.filter(x => x !== idSetor)
            }
        },
        toggleSelectAllUsuarios(checked) {
            const logins = this.filteredUsuarios.map(u => u.dsLogin)
            if (checked) {
                this.loginsSelecionados = [...new Set([...this.loginsSelecionados, ...logins])]
            } else {
                this.loginsSelecionados = this.loginsSelecionados.filter(x => !logins.includes(x))
            }
        },
        toggleSelectAllSetores(checked) {
            const ids = this.filteredSetores.map(s => s.idSetor)
            if (checked) {
                this.setoresSelecionados = [...new Set([...this.setoresSelecionados, ...ids])]
            } else {
                this.setoresSelecionados = this.setoresSelecionados.filter(x => !ids.includes(x))
            }
        },
        incluirMe() {
            if (this.loginAtual) {
                this.toggleLogin(this.loginAtual, true)
            }
        },
        limparSelecao() {
            this.loginsSelecionados = []
            this.setoresSelecionados = []
        },
        async carregarListas() {
            this.loadingListas = true
            try {
                await Promise.all([this.carregarUsuarios(), this.carregarSetores()])
            } finally {
                this.loadingListas = false
            }
        },
        async carregarUsuarios() {
            try {
                const res = await axios.get(`${urlApi}/ProcessoPermissao/GetUsuariosContrato/`)
                if (res.data?.success) {
                    const rows = res.data.data?.rows || res.data.data || []
                    if (Array.isArray(rows) && rows.length > 0) {
                        this.usuarios = rows.map(r => ({
                            dsLogin: r.dsLogin || r.usuario?.dsLogin,
                            nmUsuario: r.nmUsuario || r.usuario?.nmUsuario || r.dsLogin,
                        })).filter(u => u.dsLogin)
                        return
                    }
                }
                await this.carregarUsuariosInternos()
            } catch (e) {
                console.error(e)
                await this.carregarUsuariosInternos()
            }
        },
        async carregarUsuariosInternos() {
            try {
                const res = await axios.get(`${urlApi}/ProcessoPermissao/GetUsuariosInternosAtuais/`)
                if (res.data?.success && Array.isArray(res.data.data)) {
                    this.usuarios = res.data.data.map(item => ({
                        dsLogin: item.dsLogin,
                        nmUsuario: item.nmUsuario,
                    })).filter(u => u.dsLogin)
                } else {
                    avisoErro('Não foi possível carregar os usuários.')
                }
            } catch (e) {
                avisoErro(e?.response?.data || 'Não foi possível carregar os usuários.')
            }
        },
        async carregarSetores() {
            try {
                const res = await axios.get(`${urlApi}/Setor/Get`)
                if (res.data?.success) {
                    const rows = res.data.data?.rows || res.data.data || []
                    this.setores = (Array.isArray(rows) ? rows : []).map(s => ({
                        idSetor: s.idSetor || s.setor?.idSetor,
                        nmSetor: s.nmSetor || s.setor?.nmSetor,
                        cdSetor: s.cdSetor || s.setor?.cdSetor,
                    })).filter(s => s.idSetor)
                }
            } catch (e) {
                avisoErro(e?.response?.data || 'Não foi possível carregar os setores.')
            }
        },
        resetEstado() {
            this.loginsSelecionados = []
            this.setoresSelecionados = []
            this.filtroGlobal = ''
            this.carregando = false
        },
        confirmar() {
            if (!this.podeConfirmar) return
            this.$emit('confirmar', {
                idProcessoArtefato: this.idProcessoArtefato,
                idProcesso: this.idProcesso,
                idProcessoModeloArtefato: this.idProcessoModeloArtefato,
                cdTipoEnvolvido: this.cdTipoEnvolvido,
                Logins: [...this.loginsSelecionados],
                Setores: [...this.setoresSelecionados],
            })
        },
        abrir() {
            this.resetEstado()
            if (this.usuarios.length === 0 || this.setores.length === 0) {
                this.carregarListas()
            }
            const el = document.getElementById('ModalEscolhaEnvolvidos')
            if (!el) return
            const bs = window.bootstrap || window.Bootstrap
            bs?.Modal?.getOrCreateInstance(el)?.show()
        },
        fechar() {
            const el = document.getElementById('ModalEscolhaEnvolvidos')
            if (!el) return
            const bs = window.bootstrap || window.Bootstrap
            bs?.Modal?.getInstance(el)?.hide()
        },
        setCarregando(val) {
            this.carregando = !!val
        },
    },
    mounted() {
        this.carregarListas()
        const el = document.getElementById('ModalEscolhaEnvolvidos')
        if (el) {
            el.addEventListener('hidden.bs.modal', () => this.resetEstado())
        }
    },
}
</script>

<style lang="scss" scoped>
:deep(.modern-modal) {
    .modal-modern-content {
        border-radius: 20px;
        background: linear-gradient(135deg, #fff 0%, #f8fafc 100%);
        box-shadow: 0 22px 60px rgba(15, 23, 42, 0.16);
        position: relative;
        overflow: visible;
    }

    .modal-modern-header {
        display: flex;
        align-items: flex-start;
        gap: 18px;
        padding: 32px 32px 20px;
        position: relative;
        flex-wrap: wrap;

        &::after {
            content: '';
            position: absolute;
            bottom: -1px;
            left: 32px;
            right: 32px;
            height: 1px;
            background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.35), transparent);
        }

        .header-icon {
            width: 64px;
            height: 64px;
            border-radius: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            background: linear-gradient(135deg, rgba(59, 130, 246, 0.18) 0%, rgba(56, 189, 248, 0.18) 100%);
            color: #2563eb;

            &--revisao {
                background: linear-gradient(135deg, rgba(59, 130, 246, 0.18) 0%, rgba(56, 189, 248, 0.18) 100%);
                color: #2563eb;
            }

            &--aprovacao {
                background: linear-gradient(135deg, rgba(16, 185, 129, 0.18) 0%, rgba(52, 211, 153, 0.18) 100%);
                color: #059669;
            }
        }

        .header-text {
            flex: 1;
            min-width: 200px;

            h2 {
                margin: 0;
                font-size: 24px;
                font-weight: 700;
                color: #0f172a;
            }

            p {
                margin: 8px 0 0;
                color: #475569;
                font-size: 14px;
                line-height: 1.6;
                max-width: 520px;
            }
        }

        .header-status {
            display: flex;
            align-items: center;
            gap: 12px;
        }
    }

    .modal-modern-body {
        padding: 28px 32px 24px;
        display: flex;
        flex-direction: column;
        gap: 24px;
    }

    .section-stack {
        display: flex;
        flex-direction: column;
        gap: 22px;
    }

    .modal-modern-footer {
        padding: 0 32px 32px;

        .footer-actions {
            display: grid;
            grid-template-columns: minmax(140px, 0.35fr) 1fr;
            gap: 12px;
            align-items: stretch;
        }
    }

    .btn-modern-secondary {
        border: 2px solid rgba(148, 163, 184, 0.35);
        border-radius: 12px;
        padding: 16px 20px;
        font-weight: 700;
        letter-spacing: 0.3px;
        text-transform: uppercase;
        background: rgba(248, 250, 252, 0.95);
        color: #475569 !important;
        transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;

        &:hover:not(:disabled) {
            border-color: rgba(100, 116, 139, 0.5);
            background: #fff;
            color: #334155 !important;
        }

        &:disabled {
            opacity: 0.55;
        }
    }

    .lists-grid {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 20px;
    }

    .section-card {
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(248, 250, 252, 0.95) 100%);
        border: 1px solid rgba(226, 232, 240, 0.8);
        border-radius: 18px;
        padding: 20px 22px;
        box-shadow: 0 12px 28px rgba(148, 163, 184, 0.15);
        display: flex;
        flex-direction: column;
        gap: 18px;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
        min-height: 0;

        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 18px 36px rgba(148, 163, 184, 0.22);
        }

        &--compact {
            gap: 14px;
            padding: 18px 20px;
        }
    }

    .section-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-wrap: wrap;
        gap: 16px;

        &__info {
            display: flex;
            align-items: flex-start;
            gap: 14px;

            h3 {
                margin: 0;
                font-size: 18px;
                font-weight: 700;
                color: #1f2937;
            }

            p {
                margin: 6px 0 0;
                color: #64748b;
                font-size: 13px;
                line-height: 1.5;
            }
        }

        &__actions {
            display: flex;
            align-items: center;
            gap: 16px;
            flex-wrap: wrap;
            justify-content: flex-end;
        }
    }

    .section-icon {
        width: 44px;
        height: 44px;
        border-radius: 14px;
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.14) 0%, rgba(16, 185, 129, 0.14) 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        color: #2563eb;
        flex-shrink: 0;

        &--setor {
            background: linear-gradient(135deg, rgba(99, 102, 241, 0.14) 0%, rgba(139, 92, 246, 0.14) 100%);
            color: #6366f1;
        }
    }

    .section-content {
        display: flex;
        flex-direction: column;
        gap: 18px;
        min-height: 0;
    }

    .global-search-bar {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        align-items: center;
    }

    .btn-incluir-me {
        border-radius: 12px;
        font-weight: 600;
        white-space: nowrap;
        padding: 12px 18px;
        border-width: 2px;
    }

    .selection-summary {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.06) 0%, rgba(16, 185, 129, 0.06) 100%);
        border: 1px solid rgba(59, 130, 246, 0.2);
        border-radius: 16px;
        padding: 14px 16px;

        &__header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 10px;
        }

        &__title {
            font-weight: 700;
            font-size: 13px;
            color: #1e40af;
            text-transform: uppercase;
            letter-spacing: 0.3px;
        }
    }

    .link-limpar {
        color: #64748b;
        font-size: 13px;
        text-decoration: none;

        &:hover {
            color: #ef4444;
        }
    }

    .selection-chips {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
    }

    .selection-chip {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 6px 10px 6px 12px;
        border-radius: 999px;
        font-size: 13px;
        font-weight: 600;

        &--user {
            background: rgba(59, 130, 246, 0.12);
            border: 1px solid rgba(59, 130, 246, 0.25);
            color: #1d4ed8;
        }

        &--setor {
            background: rgba(99, 102, 241, 0.12);
            border: 1px solid rgba(99, 102, 241, 0.25);
            color: #4338ca;
        }

        .chip-remove {
            border: none;
            background: transparent;
            color: inherit;
            opacity: 0.7;
            font-size: 18px;
            line-height: 1;
            padding: 0 2px;
            cursor: pointer;

            &:hover {
                opacity: 1;
            }
        }
    }

    .dependency-toolbar {
        background: rgba(248, 250, 252, 0.9);
        border: 1px solid rgba(226, 232, 240, 0.8);
        border-radius: 16px;
        padding: 16px 18px;
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        align-items: center;
        justify-content: space-between;

        .toolbar-text {
            color: #475569;
            font-size: 13px;
            line-height: 1.5;
            flex: 1;
            min-width: 140px;
        }

        .toolbar-actions {
            display: flex;
            align-items: center;
            gap: 14px;
            flex-wrap: wrap;
            justify-content: flex-end;
        }
    }

    .modern-input {
        .input-group-text {
            background: rgba(248, 250, 252, 0.9);
            border: 1px solid rgba(203, 213, 225, 0.7);
            border-right: none;
            border-radius: 12px 0 0 12px;
            color: #64748b;
        }

        .form-control {
            border-radius: 0 12px 12px 0;
            border: 2px solid rgba(148, 163, 184, 0.22);
            background-color: #ffffff;
            padding: 12px 14px;
            font-size: 14px;
            color: #1f2937;
            transition: border-color 0.2s ease, box-shadow 0.2s ease;

            &:focus {
                border-color: rgba(37, 99, 235, 0.45);
                box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
                background-color: #ffffff;
                color: #0f172a;
            }
        }
    }

    .user-list-scroll {
        display: flex;
        flex-direction: column;
        gap: 12px;
        max-height: 280px !important;
        min-height: 120px;
        overflow-y: auto !important;
        overflow-x: hidden;
        flex-shrink: 0;
        padding-right: 4px;
        box-sizing: border-box;
    }

    .dependency-item {
        border: 1px solid rgba(226, 232, 240, 0.8);
        border-radius: 14px;
        padding: 16px 18px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 16px;
        background: rgba(255, 255, 255, 0.88);
        transition: all 0.2s ease;
        cursor: pointer;
        margin: 0;

        &:hover {
            border-color: rgba(59, 130, 246, 0.35);
            box-shadow: 0 12px 24px rgba(37, 99, 235, 0.12);
        }

        &--selected {
            border-color: rgba(59, 130, 246, 0.45);
            background: linear-gradient(135deg, rgba(59, 130, 246, 0.04) 0%, rgba(37, 99, 235, 0.06) 100%);
        }

        &__info {
            display: flex;
            align-items: center;
            gap: 16px;
            flex: 1;
            min-width: 0;
        }
    }

    .item-text {
        min-width: 0;
    }

    .dependency-title {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 6px;
        font-weight: 600;
        color: #0f172a;
        font-size: 14px;
    }

    .dependency-description {
        display: block;
        color: #64748b;
        font-size: 12px;
        margin-top: 2px;
    }

    .dep-check {
        width: 1.1rem;
        height: 1.1rem;
        margin-top: 2px;
        flex-shrink: 0;
    }

    .badge-counter {
        background: rgba(59, 130, 246, 0.12);
        border: 1px solid rgba(59, 130, 246, 0.3);
        color: #2563eb;
        font-weight: 600;
        padding: 6px 12px;
        border-radius: 999px;
        font-size: 12px;

        &--setor {
            background: rgba(99, 102, 241, 0.12);
            border-color: rgba(99, 102, 241, 0.3);
            color: #6366f1;
        }
    }

    .badge-selected {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.14) 0%, rgba(37, 99, 235, 0.14) 100%);
        color: #1d4ed8;
        border: 1px solid rgba(59, 130, 246, 0.3);
        border-radius: 999px;
        font-size: 12px;
        font-weight: 600;
        padding: 5px 12px;
        white-space: nowrap;
    }

    .badge-me {
        background: rgba(16, 185, 129, 0.15);
        color: #059669;
        border: 1px solid rgba(16, 185, 129, 0.3);
        font-size: 10px;
        font-weight: 700;
        padding: 2px 8px;
        border-radius: 999px;
        text-transform: uppercase;
    }

    .state-message {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 14px 18px;
        border-radius: 14px;
        font-size: 13px;

        &--loading {
            background: rgba(37, 99, 235, 0.08);
            color: #2563eb;
            border: 1px solid rgba(37, 99, 235, 0.18);
        }

        &--empty {
            background: rgba(248, 250, 252, 0.9);
            color: #475569;
            border: 1px dashed rgba(148, 163, 184, 0.45);
        }

        &--warning {
            background: rgba(245, 158, 11, 0.08);
            color: #b45309;
            border: 1px solid rgba(245, 158, 11, 0.25);
        }
    }

    .form-check-label {
        color: #1f2937;
        font-weight: 600;
        font-size: 13px;
    }

    .form-check-input {
        &:focus {
            border-color: rgba(37, 99, 235, 0.4);
            box-shadow: 0 0 0 0.25rem rgba(37, 99, 235, 0.18);
        }

        &:checked {
            background-color: #2563eb;
            border-color: #2563eb;
        }
    }

    .btn-modern-primary {
        border: none;
        border-radius: 12px;
        padding: 16px 22px;
        font-weight: 700;
        letter-spacing: 0.4px;
        text-transform: uppercase;
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        box-shadow: 0 14px 32px rgba(37, 99, 235, 0.35);
        color: #ffffff !important;
        transition: transform 0.2s ease, box-shadow 0.2s ease;

        &:hover:not(:disabled) {
            transform: translateY(-2px);
            box-shadow: 0 18px 40px rgba(37, 99, 235, 0.45);
            color: #ffffff !important;
        }

        &:active:not(:disabled) {
            transform: translateY(0);
        }

        &:disabled {
            opacity: 0.55;
        }
    }

    .user-list-scroll::-webkit-scrollbar {
        width: 6px;
    }

    .user-list-scroll::-webkit-scrollbar-track {
        background: rgba(241, 245, 249, 0.6);
        border-radius: 6px;
    }

    .user-list-scroll::-webkit-scrollbar-thumb {
        background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
        border-radius: 6px;

        &:hover {
            background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        }
    }

    .btn-md {
        z-index: 1001;
    }

    .spinner-border {
        color: #2563eb;
    }
}

[data-bs-theme="dark"] :deep(.modern-modal) {
    .modal-modern-content {
        background: linear-gradient(135deg, #0f172a 0%, #111827 100%) !important;
        box-shadow: 0 24px 64px rgba(0, 0, 0, 0.55);
        border: 1px solid rgba(71, 85, 105, 0.45);
    }

    .modal-modern-header {
        .header-text h2 { color: #f8fafc; }
        .header-text p { color: #cbd5f5; }

        &::after {
            background: linear-gradient(90deg, transparent, rgba(71, 85, 105, 0.55), transparent);
        }
    }

    .section-card {
        background: linear-gradient(135deg, rgba(15, 23, 42, 0.92) 0%, rgba(30, 41, 59, 0.94) 100%);
        border-color: rgba(71, 85, 105, 0.55);
        box-shadow: 0 18px 40px rgba(0, 0, 0, 0.45);
    }

    .section-header__info {
        h3 { color: #f8fafc; }
        p { color: #94a3b8; }
    }

    .section-icon {
        background: linear-gradient(135deg, rgba(37, 99, 235, 0.32) 0%, rgba(5, 150, 105, 0.26) 100%);
        color: #93c5fd;
    }

    .dependency-toolbar {
        background: rgba(15, 23, 42, 0.86);
        border-color: rgba(71, 85, 105, 0.6);

        .toolbar-text { color: #cbd5f5; }
    }

    .modern-input {
        .input-group-text {
            background: rgba(15, 23, 42, 0.82);
            border-color: rgba(71, 85, 105, 0.6);
            color: #94a3b8;
        }

        .form-control {
            background: rgba(15, 23, 42, 0.82);
            border-color: rgba(71, 85, 105, 0.6);
            color: #e2e8f0;

            &:focus {
                background-color: rgba(15, 23, 42, 0.95);
                color: #f8fafc;
            }
        }
    }

    .dependency-item {
        background: rgba(15, 23, 42, 0.9);
        border-color: rgba(71, 85, 105, 0.6);

        &:hover {
            border-color: rgba(59, 130, 246, 0.6);
            box-shadow: 0 16px 32px rgba(37, 99, 235, 0.35);
        }
    }

    .dependency-title { color: #e2e8f0; }
    .dependency-description { color: #94a3b8; }

    .badge-counter {
        background: rgba(59, 130, 246, 0.18);
        border-color: rgba(59, 130, 246, 0.35);
        color: #bfdbfe;
    }

    .badge-selected {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.24) 0%, rgba(37, 99, 235, 0.24) 100%);
        color: #bfdbfe;
        border-color: rgba(59, 130, 246, 0.4);
    }

    .state-message {
        &--loading {
            background: rgba(37, 99, 235, 0.22);
            border-color: rgba(37, 99, 235, 0.35);
            color: #bfdbfe;
        }

        &--empty {
            background: rgba(15, 23, 42, 0.82);
            border-color: rgba(71, 85, 105, 0.6);
            color: #cbd5f5;
        }

        &--warning {
            background: rgba(245, 158, 11, 0.12);
            border-color: rgba(245, 158, 11, 0.3);
            color: #fcd34d;
        }
    }

    .selection-summary {
        background: rgba(37, 99, 235, 0.12);
        border-color: rgba(59, 130, 246, 0.3);
    }

    .selection-summary__title { color: #93c5fd; }

    .form-check-label { color: #e2e8f0; }

    .form-check-input {
        background-color: rgba(15, 23, 42, 0.9);
        border-color: rgba(71, 85, 105, 0.6);

        &:checked {
            background-color: #3b82f6;
            border-color: #3b82f6;
        }
    }

    .btn-modern-primary {
        background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
        box-shadow: 0 16px 36px rgba(37, 99, 235, 0.45);
    }

    .btn-modern-secondary {
        background: rgba(15, 23, 42, 0.85);
        border-color: rgba(71, 85, 105, 0.6);
        color: #cbd5f5 !important;

        &:hover:not(:disabled) {
            background: rgba(30, 41, 59, 0.95);
            color: #f8fafc !important;
        }
    }

    .user-list-scroll::-webkit-scrollbar-track {
        background: rgba(15, 23, 42, 0.6);
    }
}

@media (max-width: 768px) {
    :deep(.modern-modal) {
        .modal-modern-header,
        .modal-modern-body,
        .modal-modern-footer {
            padding-left: 20px;
            padding-right: 20px;
        }

        .modal-modern-header {
            flex-direction: column;
            align-items: stretch;

            &::after {
                left: 20px;
                right: 20px;
            }

            .header-icon {
                width: 58px;
                height: 58px;
            }
        }

        .lists-grid {
            grid-template-columns: 1fr;
        }

        .modal-modern-footer .footer-actions {
            grid-template-columns: 1fr;
        }
    }
}

@media (max-width: 576px) {
    :deep(.modern-modal) {
        .modal-dialog {
            margin: 12px;
        }

        .modal-modern-header .header-text h2 {
            font-size: 22px;
        }

        .section-header__info {
            flex-direction: column;
        }
    }
}
</style>
